import type { WithId } from '@quromedical/fhir-common';

import { type PlanDefinition, PlanDefinitionSchema } from './schema';

export const mapPlanDefinitionModelToFhir = (
  template: PlanDefinition,
): fhir4.PlanDefinition => {
  const {
    id,
    date,
    description,
    effectivePeriod,
    questionnaires,
    status,
    title,
    version,
  } = template;

  return {
    resourceType: 'PlanDefinition',
    id,
    status,
    title,
    version,
    description,
    date,
    effectivePeriod,
    action: questionnaires.map((q) => {
      return {
        definitionCanonical: q,
      };
    }),
  };
};

export const mapFhirToPlanDefinitionModel = (
  fhir: WithId<fhir4.PlanDefinition>,
): PlanDefinition => {
  const { status, description, id, title, date, version, effectivePeriod } =
    fhir;

  const template = {
    id,
    status,
    title,
    date,
    version,
    questionnaires: fhir.action?.map((a) => a.definitionCanonical),
    description,
    effectivePeriod,
  };

  const parsed = PlanDefinitionSchema.safeParse(template);

  if (!parsed.success) {
    throw parsed.error;
  }

  return parsed.data;
};
